import React from 'react';

export default function SAP({ ...props }) {
  return (
    <svg
      width="73"
      height="37"
      viewBox="0 0 73 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M25.0048 21.8362C25.6721 22.0922 26.4477 22.2378 27.2749 22.2378C28.0798 22.2378 28.8365 22.0962 29.5014 21.8562L27.2931 14.6722H27.2495L25.0048 21.8362Z"
        fill="#10284B"
      />
      <path
        d="M42.5082 18.1218H44.0706C46.1523 18.1218 47.8134 17.4218 47.8152 15.1978C47.8152 13.049 46.153 12.3482 44.0714 12.3482H42.5082V18.1218Z"
        fill="#10284B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.3137 36.5881H0.925049V0.588135H72.925L37.3137 36.5881ZM36.5434 7.78825H43.6543C50.4264 7.78825 53.608 10.1042 53.6098 15.4234C53.6098 20.1994 50.337 23.0474 44.8004 23.0474H42.5098L42.4836 29.3978L31.7192 29.3874L30.9688 26.6354C29.8584 27.0034 28.6062 27.2082 27.2749 27.2082C25.9088 27.2082 24.6218 26.9922 23.4899 26.6018L22.4135 29.3874L16.4139 29.4066L16.683 28.005C16.6677 28.0186 16.6525 28.0322 16.6373 28.0458C16.5677 28.1079 16.4987 28.1696 16.4234 28.2306C14.8198 29.5346 12.8014 30.137 10.3145 30.1826L9.67182 30.1874C6.81449 30.1874 4.29988 29.5042 1.93091 28.1426L4.121 23.7506C6.49235 25.1674 7.98038 25.4867 9.98842 25.4434C11.0293 25.4226 11.7812 25.2306 12.2719 24.7186C12.5679 24.405 12.7231 24.0162 12.7389 23.6002C12.7587 22.4594 11.1519 21.9234 9.18505 21.3074C7.59017 20.8082 5.77999 20.1282 4.36478 19.0802C2.68996 17.8346 1.89292 16.2762 1.93249 14.0778C1.95624 12.4802 2.54195 11.0354 3.62789 9.89945C5.18558 8.27145 7.6986 7.28345 10.7166 7.28345H10.7324C13.3207 7.28585 16.4772 8.02745 18.7599 9.20185L16.2983 13.5378C13.7948 12.3154 12.5363 12.1994 11.1116 12.1218C8.98796 12.0074 7.91943 12.7746 7.9036 13.6018C7.88302 14.6098 9.91007 15.5218 11.82 16.1418C14.7121 17.0706 18.3879 18.3106 18.9498 21.9042L24.2355 7.78185H30.3752L36.5672 24.6922L36.5434 7.78825Z"
        fill="#10284B"
      />
    </svg>
  );
}
